/** Cartola → movimiento; DTE / obligación / cuota → documento. */
export const bulkUnmatchTargetNoun = (type, count = 2) => {
  const isMovement = type === "TRANSACTION";
  if (Number(count) === 1) return isMovement ? "movimiento" : "documento";
  return isMovement ? "movimientos" : "documentos";
};

export const bulkUnmatchSelectedLabel = (type) =>
  type === "TRANSACTION" ? "Movimientos seleccionados" : "Documentos seleccionados";
